import React, { useState } from 'react';
import { SearchBarContext } from '@contexts';
import { SelectOptionType } from 'types';
import { addDaysToDate } from '@utils/dates';

export const SearchBarProvider: React.FC = ({ children }) => {

    const [destinations, setDestinations] = useState<SelectOptionType[] | SelectOptionType | null>(null);

    const [duration, setDuration] = useState<number | null>(7);
    const [startDate, setStartDate] = useState<Date | null>(new Date());
    const [endDate, setEndDate] = useState<Date | null>(startDate ? new Date(addDaysToDate(startDate, duration ?? 7)) : null);

    const [roomCategory, setRoomCategory] = useState<string | null>(null)
    const [product, setProduct] = useState<string | null>(null)

    const [nbAdults, setNbAdults] = useState<number>(2); //default 2 personnes adultes
    const [nbChildren, setNbChildren] = useState<number>(0);
    const [nbBabies, setNbBabies] = useState<number>(0);
    const [childrensAges, setChildrensAges] = useState<number[]>([]);

    return <SearchBarContext.Provider value={{
        destinations,
        setDestinations,
        duration,
        setDuration,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        roomCategory,
        setRoomCategory,
        product,
        setProduct,
        nbAdults,
        setNbAdults,
        nbChildren,
        setNbChildren,
        nbBabies,
        setNbBabies,
        childrensAges,
        setChildrensAges,
    }}>
        {children}
    </SearchBarContext.Provider>
}